module.exports = __webpack_public_path__ + "static/img/ice_giant.99b8dbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/ice_giant.png
// module id = Wf8d
// module chunks = 0